import { getApiUrl } from "#/constants/environment";
import { TableRow } from "#/types/supabase";
import { fetchJson } from "#/utils/fetch";
import { Logger } from "#/lib/logging";

interface GetUserAction {
  userId?: string,
  headers?: Record<string, string>
}
export const getUserAction = async ({
  userId,
  headers
}: GetUserAction = {
  userId: undefined,
  headers: undefined
}): Promise<TableRow<"users">> => {
  const url = new URL(`${getApiUrl()}/api/user`);
  if (userId) {
    url.searchParams.append("userId", userId);
  }
  const {
    data, failure
  } = await fetchJson(url, {
    method: "GET",
    headers: {
      ...headers ?? {},
      "Cache-Control": "no-cache"
    }
  });

  if (failure) {
    throw Logger.error({
      message: "Failed to fetch user action",
      error: failure.error,
      metadata: failure.metadata
    });
  }

  return data;
};